<template>
  <div class="app-container">
    <div class="wt-form-inputs-container">
      <div class="wt-form-inputs-content">
        <el-form size="small" :inline="true" class="wt-form-inputs">
          <el-form-item label="时间：">
            <el-date-picker v-model="form.dataTimeRange"
              type="datetimerange" format="yyyy-MM-dd HH:mm:ss" value-format="yyyy-MM-dd HH:mm:ss" range-separator="至"
              start-placeholder="开始日期" end-placeholder="结束日期" :default-time="['00:00:00', '23:59:59']" :unlink-panels="true">
            </el-date-picker>
          </el-form-item>
          <el-form-item label="机构名称：">
            <el-cascader
              class="search-ascader"
              v-model="form.siteIdList"
                :options="siteOptions"
                :props="props"
                 placeholder="请选择"
                 filterable
                 collapse-tags
                clearable></el-cascader>
          </el-form-item>
          <el-button size="small" type="primary" @click="toClickAction('search')">查询</el-button>
          <el-button size="small"  @click="toClickAction('reset')">重置</el-button>
          <el-button size="small"  @click="exportChart('积分抵物业费统计')">导出</el-button>
        </el-form>
      </div>
    </div>
    <div class="chart-container">
      <div class="chart-item">
        <div class="chart-item-canvas-full" id="pointDeductChart"></div>
      </div>
    </div>
  </div>
</template>

<script>
import mixin from '../statisticalAnalysis/mixin.js'
export default {
  name: 'StatisticalAnalysisPoints',
  mixins: [mixin],
  data() {
    return {
      form: {
        dataTimeRange: [],
        communityId: '',
        siteId: ''
      },
      communityOptions: [],
      siteOptions: [],
      props: { children: 'childList', label: 'name', value: 'id', emitPath: false, expandTrigger: 'hover', multiple: true },
      chartEle: {
        totalChart: null,
        consumeChart: null,
        payChart: null
      }
    }
  },
  mounted() {
    const that = this
    window.addEventListener('resize', that.resizeView)
    this.initPage()
    this.orgTreeAllListNoSite()
  },
  beforeDestroy() {
    const that = this
    window.removeEventListener('resize', that.resizeView)
  },
  methods: {
    // 初始化页面
    initPage() {
      this.propertyStatistical()
    },
    toClickAction(type) {
      if (type === 'reset') {
        this.form = {
          dataTimeRange: []
        }
      }
      this.initPage()
    },
    exportChart(name) {
      const that = this
      const timer = (new Date()).getTime()
      const fileName = (name || '工单') + timer + '.xlsx'
      this.$wtUtil.downloadFile({
        url: window.wtConst.BASE_API + '/modules/statisticalProperty/propertyStatisticalImport',
        data: this.form,
        fileName: fileName
      }).then((res) => {
        console.log('导出成功')
      }).catch((err) => {
        that.$message({ message: err, type: 'error' })
      })
    },
    // 统计
    propertyStatistical() {
      this.$api.propertyStatistics.deduct.propertyStatistical(this.form).then(res => {
        this.$nextTick(() => {
          this.initChart(res.data ? res.data : [])
        })
      })
    },
    initChart(data) {
      this.chartEle.consumeChart = this.$echarts.init(document.getElementById('pointDeductChart'))
      const yAxisData = []; const seriesData = []
      for (const item of data) {
        yAxisData.push(item.orgName)
        seriesData.push(item.money)
      }
      const option = {
        title: {
          text: '物业费抵扣排名',
          left: 'center'
        },
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'shadow'
          },
          formatter: '{b}: {c}'
        },
        grid: {
          left: '3%',
          right: '4%',
          bottom: '3%',
          containLabel: true
        },
        xAxis: {
          type: 'value',
          boundaryGap: [0, 0.01]
        },
        yAxis: {
          type: 'category',
          data: yAxisData
        },
        color: ['#3373ca'],
        series: [{
          name: '2011',
          type: 'bar',
          data: seriesData
        }]
      }
      this.chartEle.consumeChart.setOption(option)
    },
    // 重绘
    resizeView() {
      for (const key in this.chartEle) {
        if (this.chartEle[key]) {
          this.chartEle[key].resize()
        }
      }
    },
    orgTreeAllListNoSite() {
      const c = []
      this.$api.siteManage.org.orgTreeAllListNoSite().then(res => {
        this.siteOptions = res.data.map(v => {
          delete v.childList
          return v
        })
      })
    }
    // 站点
    // orgTreeList() {
    //   this.$api.siteManage.org.orgTreeList().then(res => {
    //     this.$wtUtil.setSiteLevelKey(res.data)
    //     this.siteOptions = res.data
    //   })
    // }
  }
}
</script>
